"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _uri, _ws, _keepAliveTimeout, _reconnectionInterval, _maxReconnectionInterval, _reconnectionTimeoutInterval, _reconnectionExpiresInterval, _ackTimeout, _closing, _hashId, _cookie, _jwtUserToken, _messageId, _keepAliveInterval, _reconnectionTimeout, _reconnectionExpiresTimeout, _reconnecting, _reconnectionExpired, _ackInterval, _openingResolve, _openingReject, _pendingRequest;
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const EventBusInstance_1 = __importStar(require("../../events/EventBusInstance"));
const index_1 = require("../../events/conference/index");
const Exceptions_1 = require("../../lib/Exceptions");
/**
 * @ignore
 */
const debug = debug_1.default('vxt:ws');
/**
 * @ignore
 */
class SessionClient {
    constructor(uri, hashId, jwtUserToken) {
        _uri.set(this, void 0);
        _ws.set(this, void 0);
        /// 30 s timeout
        _keepAliveTimeout.set(this, 30000);
        // the interval between two connection trials
        _reconnectionInterval.set(this, 50);
        // the maximum interval between two connection trials
        _maxReconnectionInterval.set(this, 2000);
        // the timeout for the connection / if the ws is still trying to connect after that time, it will be closed
        _reconnectionTimeoutInterval.set(this, 2000);
        // the timeout for the connection retries / if the ws hasn't been able to connect after that time, retries will be stopped
        _reconnectionExpiresInterval.set(this, 60000);
        _ackTimeout.set(this, 300000);
        _closing.set(this, false);
        _hashId.set(this, void 0);
        _cookie.set(this, void 0);
        _jwtUserToken.set(this, void 0);
        // Unique message id incremented in send method
        _messageId.set(this, 0);
        _keepAliveInterval.set(this, void 0);
        _reconnectionTimeout.set(this, void 0);
        _reconnectionExpiresTimeout.set(this, void 0);
        _reconnecting.set(this, false);
        _reconnectionExpired.set(this, false);
        _ackInterval.set(this, void 0);
        _openingResolve.set(this, null);
        _openingReject.set(this, null);
        _pendingRequest.set(this, []);
        __classPrivateFieldSet(this, _uri, uri);
        __classPrivateFieldSet(this, _hashId, hashId);
        __classPrivateFieldSet(this, _jwtUserToken, jwtUserToken);
    }
    openSession() {
        __classPrivateFieldSet(this, _closing, false);
        let opts = undefined;
        __classPrivateFieldSet(this, _ws, new WebSocket(`${__classPrivateFieldGet(this, _uri)}/v2/session?Voxeet-Id=${__classPrivateFieldGet(this, _hashId)}&Token=${__classPrivateFieldGet(this, _jwtUserToken)}`, opts));
        __classPrivateFieldGet(this, _ws).onmessage = this.onMessage.bind(this);
        __classPrivateFieldGet(this, _ws).onopen = this.onOpen.bind(this);
        __classPrivateFieldGet(this, _ws).onclose = this.onClose.bind(this);
        __classPrivateFieldGet(this, _ws).onerror = this.onError.bind(this);
        this.startKeepAlive();
        if (__classPrivateFieldGet(this, _reconnecting)) {
            __classPrivateFieldSet(this, _reconnectionTimeout, setTimeout(() => {
                __classPrivateFieldSet(this, _reconnecting, false);
                this.closeSession();
                __classPrivateFieldSet(this, _closing, false);
                this.handleReconnection();
            }, __classPrivateFieldGet(this, _reconnectionTimeoutInterval)));
        }
        return new Promise((resolve, reject) => {
            if (!__classPrivateFieldGet(this, _openingResolve) && !__classPrivateFieldGet(this, _openingReject)) {
                __classPrivateFieldSet(this, _openingResolve, resolve);
                __classPrivateFieldSet(this, _openingReject, reject);
            }
        });
    }
    closeSession() {
        __classPrivateFieldSet(this, _closing, true);
        this.stopKeepAlive();
        if (__classPrivateFieldGet(this, _ws)) {
            __classPrivateFieldGet(this, _ws).close(1000, 'Close session.');
            __classPrivateFieldSet(this, _ws, null);
        }
        __classPrivateFieldSet(this, _pendingRequest, []);
    }
    startKeepAlive() {
        this.stopKeepAlive();
        __classPrivateFieldSet(this, _keepAliveInterval, setInterval(() => {
            if (__classPrivateFieldGet(this, _ws)) {
                if (__classPrivateFieldGet(this, _ws).readyState === WebSocket.CLOSED) {
                    this.openSession();
                }
                else {
                    this.send({ type: 'keep_alive' }, true);
                }
            }
        }, __classPrivateFieldGet(this, _keepAliveTimeout)));
    }
    stopKeepAlive() {
        if (__classPrivateFieldGet(this, _keepAliveInterval)) {
            clearInterval(__classPrivateFieldGet(this, _keepAliveInterval));
        }
    }
    send(req, ack = false) {
        debug('Sending message: ', req);
        if (!req.message_id) {
            req.message_id = __classPrivateFieldSet(this, _messageId, +__classPrivateFieldGet(this, _messageId) + 1);
        }
        if (__classPrivateFieldGet(this, _ws).readyState === WebSocket.CONNECTING) {
            __classPrivateFieldGet(this, _pendingRequest).push(req);
        }
        else {
            __classPrivateFieldGet(this, _ws).send(JSON.stringify(req));
        }
    }
    isOpen() {
        if (!__classPrivateFieldGet(this, _ws)) {
            return false;
        }
        return __classPrivateFieldGet(this, _ws).readyState === WebSocket.OPEN;
    }
    onOpen() {
        debug('WebSocket opened');
        __classPrivateFieldSet(this, _reconnecting, false);
        if (__classPrivateFieldGet(this, _openingResolve)) {
            __classPrivateFieldGet(this, _openingResolve).call(this);
            __classPrivateFieldSet(this, _openingReject, null);
            __classPrivateFieldSet(this, _openingResolve, null);
        }
        if (__classPrivateFieldGet(this, _reconnectionTimeout)) {
            clearTimeout(__classPrivateFieldGet(this, _reconnectionTimeout));
            __classPrivateFieldSet(this, _reconnectionTimeout, null);
            __classPrivateFieldSet(this, _reconnectionInterval, 50);
        }
        if (__classPrivateFieldGet(this, _reconnectionExpiresTimeout)) {
            clearTimeout(__classPrivateFieldGet(this, _reconnectionExpiresTimeout));
            __classPrivateFieldSet(this, _reconnectionExpiresTimeout, null);
        }
        while (__classPrivateFieldGet(this, _pendingRequest).length) {
            const req = __classPrivateFieldGet(this, _pendingRequest).shift();
            this.send(req);
        }
    }
    onClose(e) {
        debug('WebSocket closed');
        __classPrivateFieldSet(this, _ws, null);
        if (e.code > 1000) {
            try {
                EventBusInstance_1.default.send(index_1.ConferenceGlobalError.fromData(new Exceptions_1.WebSocketError(`${e.code} - ${e.reason}`)));
            }
            catch (error) {
                // If event bus throws an exception we sent, it means there is no 'error' event handler.
                // In this case we should only log and not rethrow to not disturb the reconnection process.
                if (error.name === 'WebSocketError') {
                    console.error(error);
                }
                else {
                    throw error;
                }
            }
        }
        this.handleReconnection();
    }
    handleReconnection() {
        if (!__classPrivateFieldGet(this, _closing)) {
            // set a timeout : when it finishes, reconnection retries are stopped
            if (!__classPrivateFieldGet(this, _reconnectionExpiresTimeout)) {
                __classPrivateFieldSet(this, _reconnectionExpiresTimeout, setTimeout(() => {
                    __classPrivateFieldSet(this, _reconnectionExpired, true);
                    const error = new Exceptions_1.WebSocketError(`Reconnection timed out`);
                    if (__classPrivateFieldGet(this, _openingReject)) {
                        __classPrivateFieldGet(this, _openingReject).call(this, error);
                        __classPrivateFieldSet(this, _openingReject, null);
                        __classPrivateFieldSet(this, _openingResolve, null);
                    }
                    EventBusInstance_1.default.send(index_1.ConferenceGlobalError.fromData(error));
                }, __classPrivateFieldGet(this, _reconnectionExpiresInterval)));
            }
            // set an interval to retry connecting to the websocket
            if (!__classPrivateFieldGet(this, _reconnecting) && !__classPrivateFieldGet(this, _reconnectionExpired)) {
                __classPrivateFieldSet(this, _reconnecting, true);
                setTimeout(() => {
                    this.openSession();
                }, __classPrivateFieldGet(this, _reconnectionInterval));
                let tmp = __classPrivateFieldGet(this, _reconnectionInterval) * 2;
                __classPrivateFieldSet(this, _reconnectionInterval, tmp > __classPrivateFieldGet(this, _maxReconnectionInterval) ? __classPrivateFieldGet(this, _maxReconnectionInterval) : tmp);
            }
        }
    }
    onError(e) {
        console.error(e);
    }
    onMessage(msg) {
        let data;
        if (msg.data) {
            data = JSON.parse(msg.data);
        }
        debug('Received data:', data.type, data);
        if (data.type === 'UpdateToken') {
            this.send({ ackMessageUuid: data.amu });
        }
        // New Event bus
        EventBusInstance_1.default.send(EventBusInstance_1.EventFactory.fromData(data));
    }
}
exports.default = SessionClient;
_uri = new WeakMap(), _ws = new WeakMap(), _keepAliveTimeout = new WeakMap(), _reconnectionInterval = new WeakMap(), _maxReconnectionInterval = new WeakMap(), _reconnectionTimeoutInterval = new WeakMap(), _reconnectionExpiresInterval = new WeakMap(), _ackTimeout = new WeakMap(), _closing = new WeakMap(), _hashId = new WeakMap(), _cookie = new WeakMap(), _jwtUserToken = new WeakMap(), _messageId = new WeakMap(), _keepAliveInterval = new WeakMap(), _reconnectionTimeout = new WeakMap(), _reconnectionExpiresTimeout = new WeakMap(), _reconnecting = new WeakMap(), _reconnectionExpired = new WeakMap(), _ackInterval = new WeakMap(), _openingResolve = new WeakMap(), _openingReject = new WeakMap(), _pendingRequest = new WeakMap();
